<div class="back-to-home rounded d-none d-sm-block">
  <a routerLink="/index" class="btn btn-icon btn-soft-primary">
    <i-feather name="home" class="icons"></i-feather>
  </a>
</div>

<!-- ERROR PAGE -->
<section class="bg-home d-flex align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-12 text-center">
        <div class="text-uppercase mt-4 display-3">Oops</div>
        <div class="text-capitalize text-dark mb-4 error-page">Page Not Found</div>
        <p class="text-muted para-desc mx-auto">You seem lost but we are glad you are here! Check out our app Surplus on the App Store and discover a simple approach to managing your finances.</p>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <div class="col-md-12 text-center">
        <a routerLink="/index" class="btn btn-outline-primary mt-4">Back</a>
        <a routerLink="/index" class="btn btn-primary mt-4 ms-2">Home</a>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- ERROR PAGE -->
